export default __webpack_public_path__ + "static/media/logo.dadeac64.svg";